var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "update-info-modal-overlay",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              _vm.$emit("close")
            }
          }
        },
        [
          _c("div", { staticClass: "update-info-modal-box" }, [
            _c("div", { staticClass: "update-info-modal-hd" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "update-info-modal-close",
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "update-info-modal-body" }, [
              _c("div", { staticClass: "update-info-img-col" }, [
                _c("div", { staticClass: "update-info-img-card" }, [
                  _c("div", { staticClass: "update-info-img-main" }, [
                    _vm.modalData.images && _vm.modalData.images.length > 0
                      ? _c("img", {
                          attrs: {
                            src: _vm.modalData.images[_vm.activeImageIndex].src,
                            alt: "メイン画像"
                          }
                        })
                      : _c(
                          "div",
                          { staticClass: "update-info-img-placeholder" },
                          [_vm._v("No Image")]
                        )
                  ]),
                  _vm._v(" "),
                  _vm.modalData.images && _vm.modalData.images.length > 0
                    ? _c("div", { staticClass: "update-info-img-date-badge" }, [
                        _c("span", { staticClass: "badge-label" }, [
                          _vm._v("更新日付")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "badge-val" }, [
                          _vm._v(
                            _vm._s(
                              _vm.modalData.images[_vm.activeImageIndex].date
                            )
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "update-info-img-strip" },
                  _vm._l(_vm.modalData.images, function(img, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "update-info-thumb",
                        class: {
                          "update-info-thumb--active":
                            idx === _vm.activeImageIndex
                        },
                        on: {
                          click: function($event) {
                            _vm.activeImageIndex = idx
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: img.srcThumbnail, alt: "Thumbnail" }
                        })
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.modalData.images &&
                _vm.modalData.images.some(function(img) {
                  return img.src
                })
                  ? _c("div", { staticClass: "update-info-img-count" }, [
                      _c("span", { staticClass: "img-count-num" }, [
                        _vm._v(
                          _vm._s(
                            _vm.modalData.images.filter(function(img) {
                              return img.src
                            }).length
                          )
                        )
                      ]),
                      _c("span", { staticClass: "img-count-unit" }, [
                        _vm._v("枚の画像")
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "update-info-info-col" }, [
                _c("span", { staticClass: "update-info-text-update-chip" }, [
                  _vm._v("\n          テキスト更新 "),
                  _c("span", { staticClass: "update-info-text-update-date" }, [
                    _vm._v(_vm._s(_vm.modalData.textUpdateDate))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "update-info-title-block" }, [
                  _c("div", { staticClass: "update-info-title-label" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "10",
                          height: "10",
                          viewBox: "0 0 10 10"
                        }
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "5",
                            cy: "5",
                            r: "4.5",
                            stroke: "#ff9900",
                            "stroke-width": "1",
                            fill: "none"
                          }
                        })
                      ]
                    ),
                    _vm._v("\n            商品タイトル\n          ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "update-info-title-text" }, [
                    _vm._v(_vm._s(_vm.modalData.title))
                  ]),
                  _vm._v(" "),
                  _vm.modalData.asin
                    ? _c("div", { staticClass: "update-info-asin-row" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "update-info-asin-badge update-info-asin-badge--asin"
                          },
                          [_vm._v("ASIN: " + _vm._s(_vm.modalData.asin))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "update-info-asin-badge" }, [
                          _vm._v(
                            "サイズ：" + _vm._s(_vm.modalData.amazonSize || "-")
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "update-info-asin-badge" }, [
                          _vm._v(
                            "カラー：" +
                              _vm._s(_vm.modalData.amazonColor || "-")
                          )
                        ])
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "update-info-review-block" }, [
                  _c("div", { staticClass: "update-info-section-label" }, [
                    _vm._v("商品説明")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "update-info-desc-wrapper" },
                    [
                      _c(
                        "div",
                        {
                          ref: "descContent",
                          staticClass: "update-info-desc-content",
                          class: {
                            "update-info-desc-content--collapsed": !_vm.isDescExpanded
                          }
                        },
                        [
                          _c("div", {
                            staticClass: "update-info-feature-text",
                            domProps: {
                              innerHTML: _vm._s(_vm.modalData.features)
                            }
                          }),
                          _vm._v(" "),
                          _vm.modalData.features && _vm.modalData.review
                            ? _c("div", {
                                staticClass: "update-info-desc-spacer"
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "update-info-review-text",
                            domProps: {
                              innerHTML: _vm._s(_vm.modalData.review)
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isOverflowing && !_vm.isDescExpanded
                        ? [
                            _c(
                              "div",
                              { staticClass: "update-info-fade-overlay" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "update-info-ellipsis" },
                                  [_vm._v("…")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "update-info-show-all-btn",
                                    on: {
                                      click: function($event) {
                                        _vm.isDescExpanded = true
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa fa-chevron-down update-info-btn-icon"
                                    }),
                                    _vm._v("すべて表示する\n                ")
                                  ]
                                )
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDescExpanded
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "update-info-show-all-btn update-info-collapse-btn",
                              on: { click: _vm.collapseDesc }
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fa fa-chevron-up update-info-btn-icon"
                              }),
                              _vm._v("折りたたむ\n            ")
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "update-info-modal-ft" }, [
              _c(
                "button",
                {
                  staticClass: "update-info-btn-cancel",
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("閉じる")]
              )
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _c("i", {
        staticClass: "fa fa-info-circle",
        staticStyle: {
          color: "#005f78",
          "font-size": "1.3em",
          "line-height": "1.2"
        }
      }),
      _vm._v("\n        商品プレビュー\n      ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09d15ae4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d15ae4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/AmazonUpdateInfoModal.vue
// module id = null
// module chunks = 